<template>
  <el-row type="flex" :gutter="20">
    Пользователи организации
  </el-row>
</template>

<script>


export default {
  name: 'User',

  components: {

  },

  data() {
    return {
      loading: false,
    }
  },
  computed: {
  },

  mounted() {

  },
  methods: {

  }
}

</script>

<style lang="scss">

.user-row-inactive {
  color: #cecece;
}

.page {

  &__head {

    &-right {
      display: flex;
      align-items: center;
    }
  }
}

.ellipsis-menu-slot {

  > span:not(:last-of-type) {
    margin-bottom: 16px;
  }
}

</style>
